




















































































































































































































import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { User } from "@/modules/auth/types";

const Auth = namespace("auth");

@Component({})
export default class Sidebar extends Vue {
  @Auth.Getter("getUser") user!: User;
  isAdmin(allowDevelopers) {
    if (allowDevelopers) return this.user.role === 0 || this.user.role === 1 || this.user.role === 3;
    else return this.user.role === 0 || this.user.role === 3;
  }
}
